<script setup lang="ts">
const { t } = useI18n();
const route = useRoute();

const { $pb } = useNuxtApp();
const dataStore = useDataStore();
</script>

<template>
  <div class=" flex gap-9">
    <ButtonLevel
      class="w-full justify-between"
      :class="{
        '!font-normal !text-gray-800': route.name !== 'account-dashboard',
      }"
      type="4"
      :title="t('Dashboard').toUpperCase()"
      @click="navigateTo('/account/dashboard')"
    />

    <ButtonLevel
      class="w-full justify-between"
      :class="{
        '!font-normal !text-gray-800': route.name !== 'account-history',
      }"
      type="4"
      :title="t('Orders_history').toUpperCase()"
      @click="navigateTo('/account/history')"
    />

    <ButtonLevel
      class="w-full justify-between"
      :class="{
        '!font-normal !text-gray-800': route.name !== 'account-delivery',
      }"
      type="4"
      :title="t('Delivery_and_invoice').toUpperCase()"
      @click="navigateTo('/account/delivery')"
    />

    <ButtonLevel
      v-if="dataStore?.user?.isReferral"
      class="w-full justify-between"
      :class="{
        '!font-normal !text-gray-800': route.name !== 'account-referral',
      }"
      type="4"
      :title="t('Referrals').toUpperCase()"
      @click="navigateTo('/account/referral')"
    />

    <ButtonLevel
      v-if="$pb.authStore?.model?.isAdmin"
      class="w-full justify-between "
      type="2"
      :title="t('Panel').toUpperCase()"
      @click="navigateTo('/panel/dashboard')"
    />
  </div>
</template>

<style scoped>

</style>
